export default "__VITE_ASSET__BBD1i6OF__"